import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { useNavigate } from 'react-router-dom';
import { GeneratePdf } from '../../components/GeneratePdf';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { getNativeSelectUtilityClasses } from '@mui/material';
import { ZodError } from 'zod';
import { studentDataStudentCredentialFormValidation } from '../../validation/Validation';
import { ErrorMessage } from '../../validation/validationError';

const SectionStudentCredentials = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();
    const authorizedAxiosSection = generateAxiosInstanceSection();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();

    const [credentials, setCredentials] = useState("");
    const [showPassword, setShowPassword] = useState([]);
    const [divisionList, setDivisionList] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const initialForm = {
        year: "",
        gradeId: "",
        divisionId: ""
    }
    const [studentData, setStudentData] = useState(initialForm);


    const initialEditForm = {
        instituteMasterId,
        sectionMasterId,
        id: "",
        studentName: "",
        email: "",
        primaryContact: "",
        secondaryContact: "",
        gender: ""
    }
    console.log({instituteMasterId})
    console.log({sectionMasterId})

    const [editStudentData, setEditStudentData] = useState(initialEditForm);
    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [studentNameSort, setStudentNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);
    const [genderSort, setGenderSort] = useState(null);
    const [userIdSort, setUserIdSort] = useState(null);
    const [academicYearSort, setAcademicYearSort] = useState(null);
    const [classSort, setClassSort] = useState(null);
    const [divisionSort, setDivisionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["student.studentName", "student.email", "student.primaryContact", "student.secondaryContact", "student.gender", "userId"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getYearList();
        getGradeList();
    }, []);

    useEffect(() => {
        getCredentials();
    }, [studentData]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getCredentials();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCredentials(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(credentials, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(credentials.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > credentials.length) {
            endIndex = credentials.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(credentials.slice(startIndex, endIndex));
    }, [credentials, currPage, itemsPerPage]);

    const getCredentials = async () => {
        try {
            const response = await authorizedAxiosSection.get(getApiUrl());
            setCredentials(response.data.result);
            // setShowPassword(Array(response.data.result.length).fill(false));
        } catch (error) {
            setCredentials([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };


    const getApiUrl = () => {
        let apiUrl = `/get-students-details?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (studentData.year !== '') {
            apiUrl += `year=${studentData.year}&`;
        }
        if (studentData.gradeId !== '') {
            apiUrl += `gradeId=${studentData.gradeId}&`;
        }
        if (studentData.divisionId !== '') {
            apiUrl += `divisionId=${studentData.divisionId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrl = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                divisionId: '',
            }
        })
        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (editId == null) {
            setStudentData((prevData) => {
                return {
                    ...prevData,
                    [name]: value
                }
            })
        } else {
            setEditStudentData((prevData) => {
                return {
                    ...prevData,
                    [name]: value
                }
            })

            if (value.trim().length !== 0) {
                setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
            }
        }
    }

    const togglePasswordVisibility = (index) => {
        setShowPassword(prevState => {
            const updatedShowPassword = [...prevState];
            updatedShowPassword[index] = !updatedShowPassword[index];
            return updatedShowPassword;
        });
    };

    const sendMail = async (email, userId, password) => {
        setLoading(true);
        const data = {
            email: email,
            userId: userId,
            password: password
        };

        const apiUrl = `/send-credential-to-mail`;

        try {
            const response = await authorizedAxiosCommon.post(apiUrl, data);
            Swal.fire({ text: response.data.message });
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false); // End loading
        }
    };

    const updateStudentData = async () => {
        try {
            console.log({editStudentData})
            await studentDataStudentCredentialFormValidation.parseAsync(editStudentData);
            setErrors([]);
            setLoading(true);

            const apiUrl = `/edit-students-details`;
            const response = await authorizedAxiosSection.put(apiUrl, editStudentData);
            setEditId(null);
            setEditStudentData(initialEditForm);
            await getCredentials();

            Swal.fire(
                { text: response.data.message }
            );
        } catch (err) {
            if (err instanceof ZodError) {
                setErrors(err.errors);
            } else {
                const errorMsg = err?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    }


    const handleInputReset = () => {
        setStudentData(initialForm);
        setDivisionList([]);

        setStudentNameSort(null);
        setEditId(null);
        setEditStudentData(initialEditForm);
        setErrors([]);
    }

    useEffect(() => {
        if (studentNameSort == true || studentNameSort == false) {
            setUserIdSort(null);
            setEmailSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [studentNameSort])

    useEffect(() => {
        if (userIdSort == true || userIdSort == false) {
            setStudentNameSort(null);
            setEmailSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [userIdSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [emailSort])

    useEffect(() => {
        if (genderSort == true || genderSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [genderSort])

    useEffect(() => {
        if (divisionSort == true || divisionSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setAcademicYearSort(null);
            setClassSort(null);
        }
    }, [divisionSort])

    useEffect(() => {
        if (academicYearSort == true || academicYearSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setClassSort(null);
        }
    }, [academicYearSort])

    useEffect(() => {
        if (classSort == true || classSort == false) {
            setEmailSort(null);
            setStudentNameSort(null);
            setUserIdSort(null);
            setGenderSort(null);
            setDivisionSort(null);
            setAcademicYearSort(null);
        }
    }, [classSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div id='scroll-up'></div>

                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>

                            <li className="breadcrumb-item active"><span>Student Credentials</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-key"></i>Student Credentials</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">

                                            {editId == null && <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='year' onChange={handleInputChange} value={studentData.year}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='gradeId' onChange={handleGradeChange} value={studentData.gradeId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='divisionId' onChange={handleInputChange} value={studentData.divisionId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>}

                                            {editId && <div className='row'>
                                                <div className="col-md-6">
                                                    <label for="studentName" className="col-form-label"><span style={{ color: "red" }}>*</span>Student Name :</label>
                                                    <input type="text" className="form-control" name="studentName" value={editStudentData.studentName} onChange={handleInputChange} />
                                                    <ErrorMessage errors={errors} field="studentName" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="email" className="col-form-label"><span style={{ color: "red" }}>*</span>Email ID :</label>
                                                    <input type="email" className="form-control" name="email" value={editStudentData.email} onChange={handleInputChange} />
                                                    <ErrorMessage errors={errors} field="email" />
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Primary Contact :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="primaryContact" value={editStudentData.primaryContact} onChange={handleInputChange} />
                                                    <ErrorMessage errors={errors} field="primaryContact" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Secondary Contact :</label>
                                                    <input type="text" onWheel={(e) => e.currentTarget.blur()} min="0" className="form-control custom-input" name="secondaryContact" value={editStudentData.secondaryContact} onChange={handleInputChange} />
                                                    <ErrorMessage errors={errors} field="secondaryContact" />
                                                </div>
                                                <div className="col-md-6 view_content_radio_btn">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Gender :</label>
                                                    <label>
                                                        <input type="radio" name="gender" value="M" checked={editStudentData.gender == "M"} onChange={handleInputChange} /> Male
                                                    </label>
                                                    <label>
                                                        <input type="radio" name="gender" value="F" checked={editStudentData.gender == "F"} onChange={handleInputChange} /> Female
                                                    </label>
                                                </div>
                                                <ErrorMessage errors={errors} field="gender" />
                                            </div>}

                                            <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    {
                                                        editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateStudentData} disabled={!editId}>Update</button>)
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <GeneratePdf id="studentCredentitals" title={credentials} headerTitle={"Student Credentials"} />
                                                        <div id="studentCredentitals">
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Student Name
                                                                                <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.studentName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Email
                                                                                <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.email"} />
                                                                            </th>
                                                                            <th scope="col">Contact Number</th>
                                                                            <th scope="col">
                                                                                Gender
                                                                                <SortIcon sortState={genderSort} setSortState={setGenderSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.gender"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Academic Year
                                                                                <SortIcon sortState={academicYearSort} setSortState={setAcademicYearSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.academicYearMasterDetails.yearName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Class
                                                                                <SortIcon sortState={classSort} setSortState={setClassSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.instituteGradeMasterDetails.gradeName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Division
                                                                                <SortIcon sortState={divisionSort} setSortState={setDivisionSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"student.instituteDivisionMasterDetails.divisionName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                User Id
                                                                                <SortIcon sortState={userIdSort} setSortState={setUserIdSort} setData={setCredentials} setCurrPage={setCurrPage} sortingPath={"userId"} />
                                                                            </th>
                                                                            <th scope="col">Password</th>
                                                                            <th scope='col'>Send Mail</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((cred, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{cred?.student?.studentName}</td>
                                                                                            <td>{cred?.student?.email}</td>
                                                                                            <td>{cred?.student?.primaryContact}, {cred?.student?.secondaryContact}</td>
                                                                                            <td>{cred?.student?.gender}</td>
                                                                                            <td>{cred?.student?.academicYearMasterDetails?.yearName}</td>
                                                                                            <td>{cred?.student?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                            <td>{cred?.student?.instituteDivisionMasterDetails?.divisionName}</td>
                                                                                            <td>{cred?.userId}</td>
                                                                                            <td>
                                                                                                {showPassword[index] ? (cred.password) : ('••••••••')}
                                                                                                <button
                                                                                                    className="btn btn-link"
                                                                                                    type="button"
                                                                                                    onClick={() => togglePasswordVisibility(index)}
                                                                                                >
                                                                                                    <i className={`fa ${showPassword[index] ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                                                                </button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-info" type="button" onClick={() => sendMail(cred.student.email, cred.userId, cred.password)}>
                                                                                                    <i className="fa fa-paper-plane"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-warning edit_icon " type="button" onClick={() => {
                                                                                                    setEditStudentData({
                                                                                                        instituteMasterId,
                                                                                                        sectionMasterId,
                                                                                                        id: cred.student.id,
                                                                                                        studentName: cred.student.studentName,
                                                                                                        email: cred.student.email,
                                                                                                        primaryContact: cred.student.primaryContact,
                                                                                                        secondaryContact: cred.student.secondaryContact,
                                                                                                        gender: cred.student.gender == 'MALE' ? 'M' : 'F'
                                                                                                    });
                                                                                                    setEditId(cred.student.id);
                                                                                                    document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                                }}><i class="fa-light fa-pen-to-square"></i></button>

                                                                                                {/* <button className="btn btn-outline-danger delete_icon" disabled={editId === activity.id} type="button" onClick={() => deleteActivity(activity.id)}>
                                                                                                    <i class="fa-light fa-trash-can"></i>
                                                                                                </button> */}
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Credentials Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={credentials.length} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionStudentCredentials;
